// tslint:disable: no-unused-expression
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { AsynchronousProgressService } from './services/TemplateServices/asynchronous-progress.service';
import { GetCurrentThemeService } from './services/TemplateServices/get-current-theme.service';

import * as Mz from "materialize-css";
import * as tvis from "vis";

@Component({
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  selector: 'app-root',
})
export class AppComponent implements OnInit, OnDestroy {

  // showProgress: switch que permite mostrar la barra de progreso cuando es verdadero
  showProgress: boolean;
  // subscriber: suscriptor que se conecta con el servicios de barra de progreso para realizar acciones cada que se ejecuten cambios
  subscriber: Subscription;

  constructor(
    private asynchronousProgressService: AsynchronousProgressService,
    private getCurrentThemeService: GetCurrentThemeService,
  ) {
    // ↓ si no existe el tema por defecto en localsotrage, lo agrega como 'balanced'
    if (!localStorage.getItem("theme")) { localStorage.setItem("theme", "balanced"); }
    // ↓ agrega a la etiqueta html el tema
    (document.querySelector("html") as HTMLElement).setAttribute("theme", localStorage.getItem("theme"));
    // ↓ Actualiza el servicio de los temas con el actual para utilizarlo en las demás páginas
    this.getCurrentThemeService.setTheme(localStorage.getItem("theme"));
    // ↓ si no existe el tema de tablas por defecto en localsotrage, lo agrega como 'theme'
    if (!localStorage.getItem("color-templates")) { localStorage.setItem("color-templates", "theme"); }
    // ↓ Actualiza el servicio de los temas para saber si las cabeceras se muestran girs o del color seleccionado
    this.getCurrentThemeService.tagStyle = localStorage.getItem("color-templates");
  }

  ngOnInit() {
    // ↓ Realiza la suscripción global al servicio de barra de progresso
    this.subscriber = this.asynchronousProgressService.emitter.subscribe((data: boolean) => {
      // ↓ Verifica si se debe mostrar/ocultar la barra de progreso
      this.showProgress !== data ? this.showProgress = data : null;
    });
  }

  // ↓ Cancela la suscripción al servicio de barra de carga
  ngOnDestroy() { this.subscriber.unsubscribe(); }

}
